import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

/** `title` — ключ словаря: AppTitleStrategy переводит его на каждой навигации; без него — WCAG 2.4.2. */
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/shell/shell').then((m) => m.Shell),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',
        title: 'HOME.PAGE_TITLE',
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
      },
      {
        path: 'cart',
        title: 'CART.TITLE',
        loadComponent: () => import('./pages/cart/cart').then((m) => m.Cart),
      },
      {
        path: 'orders',
        title: 'ORDERS.TITLE',
        canActivate: [authGuard],
        loadComponent: () => import('./pages/orders/orders').then((m) => m.Orders),
      },
      {
        path: 'orders/:orderId',
        title: 'ORDERS.DETAILS_TITLE',
        canActivate: [authGuard],
        loadComponent: () => import('./pages/orders/order-details').then((m) => m.OrderDetails),
      },
      {
        path: 'profile',
        title: 'PROFILE.TITLE',
        canActivate: [authGuard],
        loadComponent: () => import('./pages/profile/profile').then((m) => m.Profile),
      },
    ],
  },
  {
    path: 'login',
    title: 'AUTH.PHONE_TITLE',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'login/confirm',
    title: 'AUTH.CODE_TITLE',
    loadComponent: () => import('./pages/login/confirm-code').then((m) => m.ConfirmCode),
  },
  {
    path: 'login/name',
    title: 'AUTH.NAME_TITLE',
    loadComponent: () => import('./pages/login/enter-name').then((m) => m.EnterName),
  },
  {
    path: 'checkout',
    title: 'CHECKOUT.TITLE',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/checkout/checkout').then((m) => m.Checkout),
  },
  {
    path: 'addresses',
    title: 'ADDRESS.TITLE',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/addresses/addresses').then((m) => m.Addresses),
  },
  {
    // Без authGuard: список филиалов отдаётся без токена, а позвонить должен и гость.
    path: 'branches',
    title: 'BRANCHES.TITLE',
    loadComponent: () => import('./pages/branches/branches').then((m) => m.Branches),
  },
  { path: '**', redirectTo: 'home' },
];
